import React from 'react';
import {ImageGallery} from 'proxiponents';

export default function ImageGalleryManager(props) {
  return (<ImageGallery {...props}/>);
}